import TeX from '@matejmazur/react-katex';
import { Box, Typography } from '@mui/material';
// import 'katex/dist/katex.min.css';
import Markdown, { RuleType } from 'markdown-to-jsx';

interface MarkdownRenderProps {
  children?: string;
  [key: string]: any;
}

function MarkdownRender(props: MarkdownRenderProps) {
  return (
    <Markdown
      children={props.children ?? ''}
      options={{
        renderRule(next, node, renderChildren, state) {
          if (node.type === RuleType.codeBlock && node.lang === 'latex') {
            return (
              <TeX as="div" key={state.key}>
                {node.text}
              </TeX>
            );
          } else if (
            [
              RuleType.codeBlock,
              RuleType.codeFenced,
              RuleType.codeInline,
            ].includes(node.type as never)
          ) {
            if (node.type === RuleType.codeInline) {
              return (
                <Typography
                  component="span"
                  sx={{
                    fontFamily: 'monospace',
                    borderRadius: 1,
                    padding: 0.5,
                    // backgroundColor: 'rgba(0,0,0,0.1)',
                    color: 'text.secondary',
                  }}
                >
                  {node.text}
                </Typography>
              );
            }
            return (
              <Box
                sx={{
                  maxWidth: '45vw',
                  maxHeight: '50vh',
                  overflow: 'auto',
                  marginY: 2,
                  padding: 2,
                }}
                className="chat-message"
              >
                {node.type === RuleType.codeBlock && (
                  <pre
                    style={{
                      overflow: 'auto',
                      // padding: 2,
                      borderRadius: 4,
                      // margin: 2,
                      overflowWrap: 'break-word',
                      width: '100%',
                    }}
                  >
                    {node.text}
                  </pre>
                )}
                {node.type === RuleType.codeFenced && (
                  <pre
                    style={{
                      padding: '10px',
                      borderRadius: '4px',
                      overflow: 'auto',
                    }}
                  >
                    {next()}
                  </pre>
                )}
              </Box>
            );
          } else if (node.type === RuleType.image) {
            return (
              <Box
                component="span"
                sx={{ display: 'inline-block', maxWidth: '100%' }}
              >
                <img
                  src={node.target}
                  alt={node.alt}
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </Box>
            );
          } else if (node.type === RuleType.heading) {
            const variant = `h${node.level}` as
              | 'h1'
              | 'h2'
              | 'h3'
              | 'h4'
              | 'h5'
              | 'h6';
            return (
              <Typography
                variant={`h${node.level + 1}` as never}
                component={variant}
                gutterBottom
              >
                {renderChildren(node.children, state)}
              </Typography>
            );
          } else if (node.type === RuleType.paragraph) {
            return (
              <Typography variant="body1" my={1}>
                {renderChildren(node.children, state)}
              </Typography>
            );
          } else if (
            node.type === RuleType.unorderedList ||
            node.type === RuleType.orderedList
          ) {
            return (
              <Box
                component={node.type === RuleType.unorderedList ? 'ul' : 'ol'}
                sx={{
                  pl: 2,
                  listStyleType:
                    node.type === RuleType.unorderedList ? 'disc' : 'circle',
                }}
              >
                {node.items.map((item, index) => (
                  <Box component="li" key={`item-${index}`}>
                    {renderChildren(item, state)}
                  </Box>
                ))}
              </Box>
            );
          }
          return (
            <Box className="chat-message" component="span">
              {next()}
            </Box>
          );
        },
      }}
    />
  );
}

export default MarkdownRender;

export function MarkdownRenderTest() {
  return (
    <MarkdownRender>
      {'## Some important formula:\n\n```latex\n \\N = \\dfrac{1}{2}\n```\n'}
    </MarkdownRender>
  );
}
